import classes from './AspectRatioKeeper.module.css.mjs';

const aspectRatioKeeperClasses = {
  "1:1": classes.aspectRatio1x1,
  "5:4": classes.aspectRatio5x4,
  "4:5": classes.aspectRatio4x5,
  "4:3": classes.aspectRatio4x3,
  "3:4": classes.aspectRatio3x4,
  "3:2": classes.aspectRatio3x2,
  "2:3": classes.aspectRatio2x3,
  "16:10": classes.aspectRatio16x10,
  "10:16": classes.aspectRatio10x16,
  "Golden ratio": classes.aspectRatioGoldenRatio,
  "Golden ratio Portrait": classes.aspectRatioGoldenRatioPortrait,
  "16:9": classes.aspectRatio16x9,
  "9:16": classes.aspectRatio9x16,
  "2:1": classes.aspectRatio2x1,
  "1:2": classes.aspectRatio1x2,
  "21:9": classes.aspectRatio21x9,
  "9:21": classes.aspectRatio9x21,
  A4: classes.aspectRatioA4,
  "A4 Portrait": classes.aspectRatioA4Portrait,
  Letter: classes.aspectRatioLetter,
  "Letter Portrait": classes.aspectRatioLetterPortrait,
  none: classes.aspectRatioNone
};

export { aspectRatioKeeperClasses };
